import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import styles from "./ProductUpdate.module.css";
import axios, { Axios } from "axios";
import Spin from "../Spinner/Spinner";
import Popup from "../Popup/Popup";
import { API } from "../../config";
import ProductVariant from "./ProductVariant";
import Toggle from "../../utils/Toggle/Toggle";
import { FaPen, FaTrash } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import ProductVariantEdit from "./ProductVariantEdit";
import { useImageUpload } from "../ClientLogos/hooks/useImageUpload";

function ProductUpdate() {
  const [variants, setVariants] = useState([]);
  const [variant, setVariant] = useState(false);
  const [variantData, setVariantData] = useState([]);
  const [variantEdit, setVariantEdit] = useState(false);
  const [categories, setCategories] = useState([]);
  const [spin, setSpin] = useState(true);
  const [category, setCategory] = useState();
  const [sort, setSort] = useState();
  const [name, setName] = useState();
  const [type, setType] = useState();
  const [desc, setDesc] = useState("");
  const [subDesc, setSubDesc] = useState("");
  const [itemDetails, setItemDetails] = useState();
  const [cost, setCost] = useState(0);
  const [margin, setMargin] = useState(0);
  const [image, setImage] = useState([]);
  const [brand, setBrand] = useState();
  const [available, setAvailable] = useState();
  const [customisation, setCustomisation] = useState();
  const [show, setShow] = useState(false);
  const [spinn, setSpinn] = useState(false);
  const params = useParams();
  let navigate = useNavigate();

  const {
    selectedFile,
    imagePreview,
    uploadError,
    setUploadError,
    handleFileChange,
    uploadImage,
    resetImageState,
  } = useImageUpload();

  const getData = async () => {
    const data = await fetch(`${API}/Admin/category/get`);
    const json = await data.json();
    setCategories(json.allcategory);
    setSpin(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const getProductData = async () => {
    const data = await fetch(`${API}/ProductList/${params.id}`);
    const json = await data.json();
    // console.log(json);
    setCategory(json[0].categoryId);
    setSort(json[0].sortId);
    setName(json[0].name);
    setDesc(json[0].description);
    setSubDesc(json[0].sub_description);
    setItemDetails(json[0].item_Details.join("+"));
    setType(json[0].productType);
    setCost(json[0].price[0].cost);
    setMargin(json[0].price[0].margin);
    setImage(json[0].image || []);
    setBrand(json[0].brandName);
    setAvailable(json[0].available);
    setCustomisation(json[0].cust_flag);
    setSpin(false);
    setVariants(json[0].variant);
  };

  useEffect(() => {
    getProductData();
  }, []);

  const change = () => {
    setShow(false);
  };

  const saveData = async (event) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    setUploadError("");
    setSpinn(true);

    let finalImages = image;

    if (selectedFile) {
      try {
        const uploadedImageUrl = await uploadImage(selectedFile);

        if (!uploadedImageUrl) {
          setUploadError("Failed to upload image. Please try again.");
          setSpinn(false);
          return;
        }

        finalImages = [uploadedImageUrl];
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadError("An error occurred while uploading the image.");
        setSpinn(false);
        return;
      }
    }

    const data = {
      categoryId: category,
      sortId: sort,
      name: name,
      description: desc,
      sub_description: subDesc,
      item_Details: itemDetails,
      productType: type,
      cost: cost,
      margin: margin,
      image: finalImages,
      brandName: brand,
      available: available,
      cust_flag: customisation,
      createdBy: "60e9c7db11ab1428accf8278",
      updatedBy: "60e9c7db11ab1428accf8278",
      deletedBy: "60e9c7db11ab1428accf8278",
    };
    // console.log(data);
    axios
      .put(`${API}/Admin/addProduct/${params.id}`, data)
      .then((res) => {
        // console.log('Done')
        setShow(true);
        setSpinn(false);
        resetImageState();
        // console.log(res);
      })
      .catch((err) => {
        console.log(err.message);
        setSpinn(false);
      });
  };

  useEffect(() => {
    if(show) {
      setTimeout(() => {
        navigate(-1);
      }, 1000);
    }
  } , [show])

  const deleteData = () => {
    axios.delete(`${API}/Admin/addProduct/${params.id}`);
    navigate("/products");
  };

  const deleteVariantData = (e) => {
    axios.delete(`${API}/productVariant/${e}`);
    navigate("/products");
  };

  const openVariant = () => {
    setVariant(true);
  };

  const openEditVariant = (e) => {
    setVariantData(e);
    setVariantEdit(true);
  };

  return (
    <>
      {variant ? (
        <ProductVariant
          show={show}
          switch={change}
          setVariant={setVariant}
          variant={variant}
        />
      ) : null}
      {variantEdit ? (
        <ProductVariantEdit
          show={show}
          switch={change}
          setVariantEdit={setVariantEdit}
          variantEdit={variantEdit}
          variantData={variantData}
        />
      ) : null}
      {spinn ? <Spin /> : null}
      {show ? (
        <Popup show={show} switch={change} message="Updated Successfully" />
      ) : null}
      {spin ? (
        <Spin />
      ) : (
        <div className={styles.productcontainer}>
          <div className={styles.heading}>
            <div className={styles.upper}>
              <Link to="/">
                <span className={styles.swag}>
                  Website
                  <span className={styles.greater}> &gt; </span>
                </span>
              </Link>
              <Link to="/products">
                <span className={styles.swag}>
                  Products
                  <span className={styles.greater}> &gt; </span>
                </span>
              </Link>
              <span className={styles.req}>{name}</span>
            </div>
            <form onSubmit={saveData}>
              <div className={styles.productdesc}>
                <div className={styles.leftproductdesc}>
                  <h1 className={styles.details}>{name}</h1>
                  <h1 className={styles.iddetails}>ID : {params.id}</h1>
                  <div className={styles.display}>
                    {image.map((i) => {
                      return (
                        <img src={i} className={styles.imagedisplay}></img>
                      );
                    })}
                  </div>
                </div>
                <div className={styles.rightproductdesc}>
                  <div className={styles.button}>
                    <div className={styles.icon}>
                      <FaPen />
                    </div>
                    <input
                      type="submit"
                      className={styles.bttn}
                      style={{ marginRight: "20px" }}
                      value="Save"
                    />
                  </div>
                  <div className={styles.button}>
                    <div className={styles.icon}>
                      <FaTrash />
                    </div>
                    <input
                      type="submit"
                      className={styles.bttn}
                      onClick={deleteData}
                      value="Delete"
                    />
                  </div>
                </div>
              </div>
              <div className={styles.items}>
                <h1 className={styles.head}>Product Information</h1>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Product Name : </div>
                  <input
                    name="productname"
                    placeholder="Product Name"
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    id={styles.gap}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Brand Name : </div>
                  <input
                    name="fullname"
                    placeholder="Brand Name"
                    type="text"
                    onChange={(event) => setBrand(event.target.value)}
                    id={styles.gap}
                    value={brand}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Category : </div>
                  <select
                    name="category"
                    id="dropdown"
                    className={styles.select}
                    onChange={(event) => setCategory(event.target.value)}
                    value={category}
                    required
                  >
                    <option value="" disabled selected hidden>
                      {" "}
                      Choose a Category
                    </option>
                    {categories.map((c, i) => {
                      return <option value={c._id}>{c.name}</option>;
                    })}
                  </select>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Type : </div>
                  <select
                    name="producttype"
                    id="dropdown"
                    className={styles.select}
                    onChange={(event) => setType(event.target.value)}
                    value={type}
                    required
                  >
                    <option value="" disabled selected hidden>
                      {" "}
                      Choose the Type
                    </option>
                    <option value="C">Colored</option>
                    <option value="IP">Individual Products</option>
                    <option value="DC">Dual Colored</option>
                    <option value="NV">Named Variants</option>
                    <option value="UP">Unquantifiable Products</option>
                  </select>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Sort Id : </div>
                  <input
                    name="sortid"
                    placeholder="Sort ID"
                    type="number"
                    value={sort}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Availability : </div>
                  <input
                    name="availability"
                    placeholder="Availability"
                    type="text"
                    value={available ? "Available" : "Not Available"}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    disabled
                  ></input>
                  <div className={styles.togglebutton}>
                    <Toggle status={available} setStatus={setAvailable} />
                  </div>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Customisation : </div>
                  <input
                    name="customisation"
                    placeholder="Customisation"
                    type="text"
                    value={customisation ? "Available" : "Not Available"}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    disabled
                  ></input>
                  <div className={styles.togglebutton}>
                    <Toggle
                      status={customisation}
                      setStatus={setCustomisation}
                    />
                  </div>
                </div>
                <h1 className={styles.head}>Product Details</h1>
                <div className={styles.second}>
                  <div className={styles.deschead}>Description</div>
                  <textarea
                    name="desc"
                    placeholder="Description"
                    type="text"
                    onChange={(event) => setDesc(event.target.value)}
                    id={styles.desc}
                    value={desc}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second}>
                  <div className={styles.deschead}>Sub-Description</div>
                  <textarea
                    name="subdesc"
                    placeholder="Add Product Sub-Description"
                    type="text"
                    onChange={(event) => setSubDesc(event.target.value)}
                    id={styles.desc}
                    value={subDesc}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second}>
                  <div className={styles.deschead}>Item Details</div>
                  <textarea
                    name="fullname"
                    placeholder="Add Product Details"
                    type="text"
                    onChange={(event) => setItemDetails(event.target.value)}
                    id={styles.desc}
                    value={itemDetails}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second}>
                  <div className={styles.deschead}>
                    Update Product Image{" "}
                    <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                      (leave empty to keep existing image)
                    </span>
                  </div>
                  <input
                    name="product_image"
                    type="file"
                    accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                    onChange={handleFileChange}
                    id={styles.file}
                  ></input>
                  <p
                    style={{
                      fontSize: "14px",
                      fontStyle: "italic",
                    }}
                  >
                    Supported file types: JPEG, PNG, WebP
                  </p>
                  {uploadError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      {uploadError}
                    </div>
                  )}
                  {imagePreview && (
                    <div style={{ marginTop: "12px" }}>
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                          maxWidth: "200px",
                          maxHeight: "200px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  )}
                </div>
                <h1 className={styles.pricehead}>Pricing</h1>
                <div className={styles.pricesubhead}>Product</div>
                <div className={styles.pricedetails}>
                  <div className={styles.cost}>
                    <div className={styles.rupeeicon}>&#8377;</div>
                    <input
                      name="cost"
                      placeholder="Cost"
                      type="number"
                      onChange={(event) => setCost(+event.target.value)}
                      id={styles.gaphalfirst}
                      step=".01"
                      value={cost}
                      required
                    ></input>
                  </div>
                </div>
                <div className={styles.pricesubhead}>Margin</div>
                <div className={styles.second}>
                  <input
                    name="margin"
                    placeholder="Margin"
                    type="number"
                    onChange={(event) => setMargin(+event.target.value)}
                    id={styles.pricegap}
                    value={margin}
                    step=".01"
                    required
                  ></input>
                  <div className={styles.percenticon}>%</div>
                </div>
                <div className={styles.pricesubhead}>Final Cost</div>
                <div className={styles.second}>
                  <div className={styles.cost}>
                    <div className={styles.rupeeicon}>&#8377;</div>
                    <input
                      name="total"
                      placeholder="Final Cost"
                      type="number"
                      id={styles.pricegap}
                      value={Math.round(cost * (1 + margin / 100))}
                      disabled
                    ></input>
                  </div>
                </div>
                <h1 className={styles.head}>Variants</h1>
                <div className={styles.variantbutton} onClick={openVariant}>
                  <div style={{ marginRight: "24px" }}>
                    <AiOutlinePlus />
                  </div>
                  <div>Add Variants</div>
                </div>
                {variants.map((i, index) => {
                  return (
                    <div className={styles.variantbox}>
                      <div className={styles.uppervariant}>
                        <div className={styles.variantname}>
                          {type === "C" || type === "DC"
                            ? index + 1 + ". " + i.colorName
                            : index + 1 + ". " + i.varName}
                        </div>
                        <div className={styles.rightproductdesc}>
                          <div className={styles.button}>
                            <div className={styles.icon}>
                              <FaPen />
                            </div>
                            <input
                              type="reset"
                              className={styles.bttn}
                              style={{ marginRight: "20px" }}
                              onClick={() => openEditVariant(i)}
                              value="Edit"
                            />
                          </div>
                          <div className={styles.button}>
                            <div className={styles.icon}>
                              <FaTrash />
                            </div>
                            <input
                              type="reset"
                              className={styles.bttn}
                              onClick={() => deleteVariantData(i._id)}
                              value="Delete"
                            />
                          </div>
                        </div>
                      </div>
                      {type === "C" || type === "DC" ? (
                        <div className={styles.third}>
                          <div className={styles.varianthead}>Hex Code : </div>
                          <input
                            name="hexcode"
                            placeholder="Hex Code"
                            type="text"
                            value={i.hexColor}
                            id={styles.gap}
                            disabled
                          ></input>
                        </div>
                      ) : null}
                      <div className={styles.third}>
                        <div className={styles.varianthead}>SKU : </div>
                        <input
                          name="hexcode"
                          placeholder="SKU"
                          type="text"
                          value={i.sku}
                          id={styles.gap}
                          disabled
                        ></input>
                      </div>
                      <div className={styles.variantname}>Mockups</div>
                      <div className={styles.imagecaraousel}>
                        <div className={styles.variantimagedisplay}>
                          {(i.images || []).map((img, imgIndex) => {
                            return (
                              <img
                                src={img}
                                className={styles.variantimage}
                              ></img>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductUpdate;
